export class OutletItem {
    id: string;
    parentId?: string;
    
    name: string;
    subheading?: string;
    expandMessage?: string;
    canonicalUrl?: string;
    slug?: string;
    fullSlug?: string;
    imgSrc?: string;
    bannerImgSrc?: string;
    iconName?: string;
    iconColor?: string;
    isActive: boolean;
    sortOrder: number;
    type: string; // CATEGORY, SEARCH
    description?: string; // HTML description for category and search items
    
    //SEARCH
    searchQuery?: string;
    maxPrice?: number; // 0 indicates disabled
    minPercentOff?: number; // 0 indicates disabled
    lastUpdated?: Date | string; // Last time search results were updated
    
}